export default {
  name: 'OnboardingIndex',
  props: {
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      default: 'Access your orchestrated logic workspace.'
    },
    submit_button_text: {
      type: String,
      default: "Submit",
    },
    url_forgot_password: {
      type: String,
      default: "#"
    },
    verification_running: {
      type: Boolean,
      default: false,
    },
    hide_submit_button: {
      type: Boolean,
      default: false
    },
    custom_submit_button: {
      type: Boolean,
      default: false
    },
    brand_name: {
      type: String,
      default: 'LogicStream'
    }
  },
  data() {
    return {
      username: "",
      password: ""
    };
  },
  computed: {
    onboardingBackgroundStyle() {
      const onboardingImage = this.$clientImage?.onboarding || this.$clientImage?.background;

      return onboardingImage ? {
        backgroundImage: `url(${onboardingImage})`,
      } : {};
    },
    show_default_submit_button() {
      return !this.hide_submit_button && !this.custom_submit_button;
    }
  },
  methods: {
    submitForm() {
      this.$emit('custom-submit', { username: this.username, password: this.password });
    }
  }
};
